import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const STORAGE_KEY = 'decida_consent'

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Small delay so it doesn't flash immediately on load
      const t = setTimeout(() => setVisible(true), 800)
      return () => clearTimeout(t)
    }
  }, [])

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'all')
    setVisible(false)
  }

  function reject() {
    localStorage.setItem(STORAGE_KEY, 'essential')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6
                 flex justify-center"
    >
      <div
        className="w-full max-w-2xl bg-[#1F2933] text-white rounded-2xl
                   shadow-2xl px-6 py-5 flex flex-col sm:flex-row
                   items-start sm:items-center gap-4"
      >
        {/* Text */}
        <p className="text-sm text-gray-300 leading-relaxed flex-1">
          We use cookies to improve your experience and analyze Platform usage.
          See our{' '}
          <button
            onClick={() => navigate('/cookies')}
            className="underline text-white hover:text-[#0E7C86] transition-colors"
          >
            Cookie Policy
          </button>{' '}
          for details.
        </p>

        {/* Buttons */}
        <div className="flex gap-3 shrink-0">
          <button
            onClick={reject}
            className="px-4 py-2 rounded-lg text-sm font-medium
                       border border-white/20 text-gray-300
                       hover:bg-white/10 transition-colors duration-200"
          >
            Reject Non-Essential
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 rounded-lg text-sm font-semibold
                       bg-[#0E7C86] text-white
                       hover:bg-[#0a6570] transition-colors duration-200"
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  )
}
